<script>
import newsService from "~/service/newsService";

export default {
  name: "NewsAlert",
  render: () => null,
  data() {
    return {
      newsList: []
    };
  },
  methods: {
    async reload() {
      let _this = this;
      _this.newsList = await newsService.feed();
      if (_this.newsList) {
        _this.newsList.forEach(async news => {
          await _this.$dialog.confirm({
            text: news.descr,
            title: news.title,
            icon: false,
            actions: {
              true: {
                color: "red",
                text: "Ok",
                handle: async () => {
                  await newsService.markAsRead(news.newsId);
                }
              }
            }
          });
        });
      }
    }
  },
  mounted() {
    this.reload();
  }
};
</script>
